"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRLSTestingEnabled = void 0;
const isRLSTestingEnabled = () => {
    const allowedNamespaces = [
        "cfesuite-test",
        "cfesuite-local",
        "cfesuite-dev",
        "cfesuite-staging",
    ];
    return !!process.env.K8S_NAMESPACE && allowedNamespaces.includes(process.env.K8S_NAMESPACE);
};
exports.isRLSTestingEnabled = isRLSTestingEnabled;
//# sourceMappingURL=rls-testing.js.map